import axiosCommon from '@/api/axiosCommon'
let statis = {
    namespaced: true,
    state: {
        licenses: 0
    },
    mutations: {
        setTotal(state,data){
            state.licenses = data
        }
    },
    actions: {
        async getTotal({
            commit,
        }) {
            let res = await axiosCommon.get('/rest/stat/getOverview')
            commit('setTotal',res.licenses)
            return res
        },
        async getBar({
            commit,
            state
        },payload) {
            let res = await axiosCommon.post('/rest/stat/getBarChart',payload)
            return res
        },
        async getPie({
            commit,
            state
        },payload) {
            let res = await axiosCommon.post('/rest/stat/getPieChart',payload)
            return res
        },
        async getPieList({
            commit,
            state
        },payload) {
            let res = await axiosCommon.post('/rest/stat/getPieList',payload)
            return res
        }
    }
}

export default statis